export default __webpack_public_path__ + "static/media/3.eba38d17.png";